export default {
  clean: () => import("/tmp/build_58fff9e7/layouts/clean.vue"),
  default: () => import("/tmp/build_58fff9e7/layouts/default.vue")
}